<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Criação de Usuário/Escola</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field name="nome" :rules="nomeRules" label="Nome da escola" type="text"
                                          v-model="nome" data-cy="joinEmailField" required>
                            </v-text-field>
                            <v-text-field prepend-icon="person" name="email" label="Email" type="email"
                                          v-model="email" :rules="emailRules" data-cy="joinEmailField" required>
                            </v-text-field>
                            <v-text-field prepend-icon="lock" name="password" label="Password"
                                          type="password" required v-model="password" :rules="passwordRules"
                                          data-cy="joinPasswordField">
                            </v-text-field>
                            <progress value="0" max="100" id="uploader">0</progress>
                            <input type="file" @change="onFileSelected" id="fileButton" />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="submit" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <!--v-btn color="green darken-1" flat @click="closeModal">OK</v-btn-->
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties } from '@/global.js'

export default {
    name: 'Cadastro-Usuarios-Adicionar-Escola',
    directives: {mask},
    data() {
        return {
            valid: false,
            nome: '',
            email: '',
            password: '',
            perfil: '2',
            escolaID: 0,
            dialog: false,
            loading: false,
            slug: this.slug,
            extensao : null,
            statusUpload: false,
            tituloModal: "Usuário cadastrado com sucesso!",
            nomeRules: [
                v => !!v || 'Nome é obrigatório',
                v =>
                    v.length >= 4 ||
                    'A senha deve ter mais de 3 characteres'
            ],
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail deve ser válido.'
            ],
            passwordRules: [
                v => !!v || 'Senha obrigatória',
                v =>
                    v.length >= 7 ||
                    'A senha deve ter mais de 6 characteres'
            ]
        };
    },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        setProfile(){
           
           db.collection('usuarios').add({
                nome: this.nome,
                email: this.email,
                perfil: this.perfil,
                escolaID: 0,
                slug: this.slug,
                extensao: this.extensao,
                tokenFMC: null
            })
            .then(docRef => {
                console.log('Document written with ID: ', docRef.id);
                //this.$router.push(`/${slug}/success`)
                this.loading = false
                this.dialog = true
                
            })
            .catch(function (error) {
                console.log('Error adding document: ', error);
                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
            })

            
        },
        submit() {
            if(userProperties.escolaID != null){

                if (this.$refs.form.validate() && this.statusUpload == true) {
                    this.loading = true;
                    this.$store.dispatch('userJoin', {
                        email: this.email,
                        password: this.password
                    })
                    .then(data => {
                        console.log('Login e senha criados com sucesso.' + data);
                        this.setProfile();
                    })
                    .catch(function (error) {
                        console.log('Erro ao criar login e senha ', error);
                    })
                }
                if (this.$refs.form.validate() && this.statusUpload == false) {
                    alert("Por favor, faça o upload da foto do perfil do usuário")
                }
            } 
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },        
        onFileSelected(event){

            console.log(event);
            var file = event.target.files[0]
            var filename = event.target.files[0].name
            
            // Recupera imagem do storage
            var storageRef = firebase.storage().ref('profile/'+this.slug+"."+filename.toString().split(".")[1])
            this.extensao = filename.toString().split(".")[1];
            var task = storageRef.put(file)
            var that = this;
            task.on('state_changed',
                function progress(snapshot){
                    var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    uploader.value = percentage;
                },
                function error(err){
                    alert("Error on upload. Check if image size is less than 900KB");
                    that.statusUpload = false;
                },
                function complete(){
                    that.extensao = filename.toString().split(".")[1];
                    that.statusUpload = true;
                    alert("Upload successful!");
                }
            )
        }
        
    },
    mounted() { 

        // se perfil não for admin
        if(userProperties.perfil != 1){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

       const slug = this.generateUUID()
        this.slug = slug;
       //alert(userProperties.perfil);
       //userProperties.perfil = "test2";
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }
</style>
